module.exports = __webpack_public_path__ + "static/media/iphone_12_mini_purple.623600b4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/custom-products/iphone/iphone_12_mini_purple.png
// module id = 2086
// module chunks = 0